import { User } from 'api';
import { get } from 'lodash';
import { Toastr } from 'modules/toastr';
import queryString from 'query-string';
import React from 'react';
import cookie from 'react-cookie';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

class LoginSSO extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  componentDidMount() {
    const parsed = queryString.parse(window.location.search);
    const error = get(parsed, 'error');
    const errorDescription = get(parsed, 'error_description');
    const accessToken = get(parsed, 'access_token');

    if (error !== 'false') {
      Toastr(decodeURIComponent(errorDescription), 'error');
      this.changePage('/dang-nhap')
    }

    if (accessToken) {
      cookie.save('accessToken', accessToken);
      User.actions.loginSSO.request(null, {}).then(res => {
        const attributes = get(res, 'data.attributes');
        if (res && res.data) {
          localStorage.clear();
          let userData = {
            id: get(attributes, 'congChucId'),
            name: get(attributes, 'hoVaTen'),
            chucVu: get(attributes, 'chucVu'),
            tenVaiTro: get(attributes, 'tenVaiTro'),
            coQuanQuanLyId: get(attributes, 'coQuanQuanLyId'),
            vaiTroMacDinhId: get(attributes, 'vaiTroMacDinhId'),
            loaiVaiTroMacDinh: get(attributes, 'loaiVaiTroMacDinh'),
            roles: get(attributes, 'roles').map((item) => ({
              loaiVaiTro: item.loaiVaiTro,
              vaiTroId: item.vaiTroId,
              ten: item.ten,
              quyen: item.quyen
            })),
            quyenBatDauQuyTrinh: get(attributes, 'quyenBatDauQuyTrinh'),
            donViId: get(attributes, 'donViId'),
            donViChaId: get(attributes, 'donViChaId'),
            tenCoQuanQuanLy: get(attributes, 'tenCoQuanQuanLy'),
            capCoQuanQuanLyId: get(attributes, 'capCoQuanQuanLyId'),
            capCoQuanQuanLyCuaDonViId: get(attributes, 'capCoQuanQuanLyCuaDonViId'),
            capCoQuanQuanLyCuaDonViChaId: get(attributes, 'capCoQuanQuanLyCuaDonViChaId'),
            isBoSungThongTin: get(attributes, 'isBoSungThongTin'),
            sso: get(attributes, 'SSO'),
            ssoIdToken: get(attributes, 'ssoIdToken')
          }
          localStorage.setItem('userInfo', JSON.stringify(userData));
          this.props.dispatch({
            type: 'INIT_DULIEU',
            value: true
          });
          browserHistory.push('/');
        }
      }).catch((error) => {
        if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
          Toastr(error.response.data.errors[0].detail, 'error');
          this.clearAllCookie();
          this.changePage('/dang-nhap')
        }
      });
    }
  }

  clearAllCookie() {
    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  }

  changePage(name) {
    browserHistory.push(name);
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

export default connect()(LoginSSO);



// WEBPACK FOOTER //
// ./src/components/modules/login-sso/LoginSSO.jsx